export const SHOWED_MODAL = "SHOWED_MODAL";
export const HID_MODAL = "HID_MODAL";
